var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLoginPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.86 19.64H3.23C1.45 19.64 0 18.19 0 16.41V9.70998C0 7.92998 1.45 6.47998 3.23 6.47998H12.86C14.64 6.47998 16.09 7.92998 16.09 9.70998V16.41C16.09 18.19 14.64 19.64 12.86 19.64ZM3.23 7.93998C2.26 7.93998 1.46 8.72998 1.46 9.69998V16.4C1.46 17.37 2.25 18.17 3.23 18.17H12.86C13.83 18.17 14.63 17.38 14.63 16.4V9.69998C14.63 8.72998 13.84 7.93998 12.86 7.93998H3.23Z",
    fill: "#8E8EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0898 7.69C11.6898 7.69 11.3598 7.36 11.3598 6.96V4.78C11.3598 2.95 9.86977 1.46 8.03977 1.46C6.20977 1.46 4.71977 2.95 4.71977 4.78V6.96C4.71977 7.36 4.38977 7.69 3.98977 7.69C3.58977 7.69 3.25977 7.36 3.25977 6.96V4.78C3.25977 2.14 5.40977 0 8.03977 0C10.6698 0 12.8198 2.14 12.8198 4.78V6.96C12.8198 7.36 12.4898 7.69 12.0898 7.69Z",
    fill: "#8E8EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03957 15.7999C7.63957 15.7999 7.30957 15.5799 7.30957 15.3099V13.4099C7.30957 13.1399 7.63957 12.9199 8.03957 12.9199C8.43957 12.9199 8.76957 13.1399 8.76957 13.4099V15.3099C8.76957 15.5799 8.43957 15.7999 8.03957 15.7999Z",
    fill: "#8E8EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04035 14.38C6.84035 14.38 5.86035 13.4 5.86035 12.2C5.86035 11 6.84035 10.02 8.04035 10.02C9.24035 10.02 10.2204 11 10.2204 12.2C10.2204 13.4 9.24035 14.38 8.04035 14.38ZM8.04035 11.48C7.64035 11.48 7.32035 11.8 7.32035 12.2C7.32035 12.6 7.64035 12.92 8.04035 12.92C8.44035 12.92 8.76035 12.6 8.76035 12.2C8.76035 11.8 8.44035 11.48 8.04035 11.48Z",
    fill: "#8E8EA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_1171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.08,
    height: 19.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoginPassword);
export default __webpack_public_path__ + "static/media/ico-login-password.afa9ebc4a434f1e66a90bd48ea7fee01.svg";
export { ForwardRef as ReactComponent };